import _typeof from "@babel/runtime/helpers/typeof";
import _useRequest from "@byted/hooks/es/useRequest";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import { StarTheme, LikeTheme } from '@src/utils/api/vote';
import style from './style.less';
import { IconStarFill, IconLoading } from '@arco-design/web-react/icon';
var IconFillCopy = function IconFillCopy() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.2158V3.90625C6.5 3.1296 7.1296 2.5 7.90625 2.5H20.0937C20.8704 2.5 21.5 3.1296 21.5 3.90625V16.0938C21.5 16.8704 20.8704 17.5 20.0937 17.5H17.7581",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 6.5H3.90625C3.1296 6.5 2.5 7.1296 2.5 7.90625V20.0937C2.5 20.8704 3.1296 21.5 3.90625 21.5H16.0938C16.8704 21.5 17.5 20.8704 17.5 20.0937V7.90625C17.5 7.1296 16.8704 6.5 16.0938 6.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }));
};
var IconFillEye = function IconFillEye() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 10",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9648 4.81044C12.7329 2.06247 10.0322 0.261963 7 0.261963C3.96778 0.261963 1.2671 2.06247 0.0352365 4.81044C-0.0117455 4.95264 -0.0117455 5.04723 0.0352365 5.18943C1.2671 7.93741 3.96763 9.73791 7 9.73791C10.0324 9.73791 12.7329 7.93694 13.9648 5.18943C14.0117 5.04723 14.0117 4.95264 13.9648 4.81044ZM7 7.65489C5.5398 7.65489 4.34505 6.46014 4.34505 4.99994C4.34505 3.53974 5.5398 2.34499 7 2.34499C8.4602 2.34499 9.65495 3.53974 9.65495 4.99994C9.65495 6.46014 8.4602 7.65489 7 7.65489Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6543 4.99976C8.6543 5.90976 7.90973 6.65406 7 6.65406C6.09027 6.65406 5.3457 5.90976 5.3457 4.99976C5.3457 4.08976 6.09027 3.34546 7 3.34546C7.90973 3.34546 8.6543 4.08989 8.6543 4.99976Z",
    fill: "currentColor"
  }));
};
var IconFillLike = function IconFillLike(prop) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: prop.className
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3376 1.24564L13.52 1.33113C14.7359 1.91736 16.5018 3.10077 16.5018 5.00064C16.5018 5.75392 16.1674 6.75295 15.4985 7.99773H19.2877C22.2716 7.99773 22.957 10.6316 22.2716 12.6052L19.2877 20.4603C19.0356 21.3739 18.1959 22.0077 17.2376 22.0077H4.99264V7.99773H7.03961L11.4897 1.66726C11.7707 1.22021 12.5292 0.877492 13.3376 1.24564ZM3.5 7.99927V21.9993H1.5V7.99927H3.5Z",
    fill: "currentColor"
  }));
};
var VoteIcon = function VoteIcon(props) {
  var theme = props.theme,
    type = props.type,
    showCount = props.showCount;
  var countType = {
    like: 'likeCount',
    star: 'starCount',
    copy: 'copyCount',
    view: 'viewCount'
  }[type];
  var _a = __read(React.useState(props.theme.statistic), 2),
    innerStatistic = _a[0],
    setStatistic = _a[1];
  React.useEffect(function () {
    setStatistic(props.theme.statistic);
  }, [props.theme.statistic]);
  var statistic = __assign({
    like: false,
    star: false,
    likeCount: 0,
    starCount: 0
  }, innerStatistic);
  var _b = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var newStatistic;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (type !== 'like' && type !== 'star') {
                return [2];
              }
              if (!(type === 'like')) return [3, 2];
              return [4, LikeTheme({
                themeId: theme.themeId
              })];
            case 1:
              _a.sent();
              return [3, 4];
            case 2:
              return [4, StarTheme({
                themeId: theme.themeId
              })];
            case 3:
              _a.sent();
              _a.label = 4;
            case 4:
              newStatistic = __assign(__assign({}, statistic), type === 'like' ? {
                like: !statistic.like,
                likeCount: statistic.likeCount + (statistic.like ? -1 : 1)
              } : {
                star: !statistic.star,
                starCount: statistic.starCount + (statistic.star ? -1 : 1)
              });
              setStatistic(newStatistic);
              props.onOk && props.onOk(newStatistic);
              return [2];
          }
        });
      });
    }),
    loading = _b.loading,
    run = _b.run;
  var renderCount = function renderCount() {
    var number = statistic[countType] || 0;
    var countStyle = _typeof(showCount) === 'object' ? showCount.style : {};
    return showCount ? /*#__PURE__*/React.createElement("span", {
      className: style['vote-count'],
      style: countStyle
    }, number) : null;
  };
  var render = props.render || function (dom) {
    return dom;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: style['vote'],
    onClick: function onClick(e) {
      e.preventDefault();
      !loading && run();
    }
  }, render( /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(IconLoading, {
    style: {
      color: 'rgb(var(--primary-6))'
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, props.type === 'like' && /*#__PURE__*/React.createElement(IconFillLike, {
    className: style['like-icon'] + " " + (statistic.like ? style['like-icon-active'] : '')
  }), props.type === 'star' && /*#__PURE__*/React.createElement(IconStarFill, {
    className: style['star-icon'] + " " + (statistic.star ? style['star-icon-active'] : '')
  }), props.type === 'copy' && /*#__PURE__*/React.createElement(IconFillCopy, null), props.type === 'view' && /*#__PURE__*/React.createElement(IconFillEye, null)), renderCount())));
};
export default VoteIcon;